









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class IframeLoading extends Vue {
  @Prop({ required: true }) 
  src: string

  @Prop({ default: () => () => {} })
  load: ()=>void

  loading = true

  onLoad(){
    this.loading = false
    this.load()
  }
}
